import { createAction, props } from '@ngrx/store';
import { AMNoteItem } from 'src/app/accountmanagers/submittals/model/am-submittals.model';
import { ClinicalReviewHistory } from '../../review-queue/models/clinical-review-history.model';

export const loadCandidateClinicalHistory = createAction(
    '[CLINICAL REVIEW HISTORY] Load Candidate Clinical History',
    props<{
        candidateId: number;
    }>()
);

export const loadCandidateClinicalHistorySuccess = createAction(
    '[CLINICAL REVIEW HISTORY] Load Candidate Clinical History Success',
    props<{
        candidateId: number;
        history: ClinicalReviewHistory[];
    }>()
);

export const loadCandidateClinicalHistoryFailed = createAction(
    '[CLINICAL REVIEW HISTORY] Load Candidate Clinical History Failed',
    props<{
        error: string;
        exception: unknown;
    }>()
);

export const loadSubmittalNotes = createAction(
    '[CLINICAL REVIEW HISTORY] Load Submittal Notes',
    props<{
        submittalId: number;
    }>()
);

export const loadSubmittalNotesSuccess = createAction(
    '[CLINICAL REVIEW HISTORY] Load Submittal Notes Success',
    props<{
        submittalId: number;
        notes: AMNoteItem[];
    }>()
);

export const loadSubmittalNotesFailed = createAction(
    '[CLINICAL REVIEW HISTORY] Load Submittal Notes Failed',
    props<{
        error: string;
        exception: unknown;
    }>()
);
